<template>
    <vs-navbar class="nabarx">
      <div slot="title">
        <vs-navbar-title>
          <Logo />
          CEMACO
        </vs-navbar-title>
      </div>
    </vs-navbar>
</template>
<script>
import Logo from './Logo'
export default {
    components: {
        Logo
    }
}
</script>